import React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { FilterIcon, MenuArrow } from './lib';

export default function Actions({
  activeFloorplan,
  className,
  filterCount,
  minZoom,
  plan,
  setActiveFloorplan,
  setShowFilters,
  zoomOut,
}) {
  // Find the currently active floorplan
  const floorPlanLabel = (availableFloorplans) => {
    if (!availableFloorplans.length > 0) {
      return '';
    }

    // Take the ID of the currently selected floorplan
    if (activeFloorplan && activeFloorplan?.id) {
      const activePlan = availableFloorplans.find(
        (fPlan) => fPlan.id === activeFloorplan.id
      );

      // And find the name to display on the dropdown select for that floorplan
      if (activePlan?.name) {
        return activePlan.name;
      }
    } else {
      // If no floorplan has been selected, it will default to show the first plan
      return availableFloorplans[0].name;
    }

    return '';
  };

  // Don't render the actions menu if this is a hotspot tab as this doesn't have filters
  if (plan.type === 'hotspots') {
    return <></>;
  }

  return (
    <div className={`siteplan__actions${className ? ` ${className}` : ''}`}>
      <button
        className="button button--clear siteplan__filter-button"
        onClick={() => setShowFilters(true)}
        type="button"
      >
        <FilterIcon />
        <span className="siteplan__filter-label">{`Filter${
          filterCount > 0 ? ` (${filterCount})` : ''
        }`}</span>
      </button>

      {plan.type === 'apartment' && plan?.floorplans?.length > 0 && (
        <div className="siteplan__floor-selector">
          <DropdownMenu.Root modal={false}>
            <DropdownMenu.Trigger asChild>
              <button className="siteplan__floor-select" type="button">
                <span className="siteplan__floor-label">
                  {floorPlanLabel(plan.floorplans)}
                </span>
                <MenuArrow />
              </button>
            </DropdownMenu.Trigger>

            <DropdownMenu.Content
              align="start"
              avoidCollisions={false}
              className="siteplan__floor-list"
            >
              {plan.floorplans.map((floorplan, i) => (
                <DropdownMenu.Item
                  key={`selector-${floorplan.id}`}
                  className="siteplan__floor-item"
                >
                  <button
                    className={`siteplan__floor-button${
                      activeFloorplan && floorplan.id === activeFloorplan?.id
                        ? ' siteplan__floor-button--active'
                        : ''
                    }${
                      !activeFloorplan && i === 0
                        ? ' siteplan__floor-button--active'
                        : ''
                    }`}
                    type="button"
                    onClick={() => {
                      setActiveFloorplan(floorplan);
                      zoomOut(minZoom);
                    }}
                  >
                    {floorplan.name}
                  </button>
                </DropdownMenu.Item>
              ))}
            </DropdownMenu.Content>
          </DropdownMenu.Root>
        </div>
      )}
    </div>
  );
}
